//Authenticate
export const apiLogin = `/1.0/auth/login`
export const apiLogout = `/1.0/auth/logout`
export const apiProfile = `/1.0/auth/user`
export const apiRegister = `1.0/saff/create`
export const apiGetCategoriesIncludeRoles = `/chuyendoiso/api/v1/GetCategoriesIncludeRoles`
export const apiGetUserToRole = `/chuyendoiso/api/v1/GetUserToRole`
export const apiCreateRoleGroup = `/chuyendoiso/api/v1/CreateRoleGroup`
export const apiUpdateRoleGroup = `/chuyendoiso/api/v1/UpdateRoleGroup`
export const apiGetPersonalList = `/1.0/personnel/list`






export const apiRegisterAccount = `Authservice/RegisterAccount`
export const apiForgotPassword = `1.0/forgot/password`
export const apiChangePassword = `Authservice/ChangePassword`
export const apiVerifyCode = `Authservice/VerifyCode`


